module.exports = __webpack_public_path__ + "static/media/Sqlmap.c5e91667.png";